import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import CroField from "../../components/generalForm/CroField";
import CroLabeledCmp from "../../components/generalForm/CroLabeledCmp";
import { styles } from "../../index";
import * as V from "../../../../utils/formValidation";

class OneFieldForm extends Component {
  componentWillMount() {
    this.props.breadcrumbs(this.props.breadcrumbsItems);
  }

  render() {
    const {
      error,
      onSubmit,
      handleSubmit,
      goBack,
      submitting,
      submitLabel,
      disabled,
      title,
      name,
      multiLine,
    } = this.props;
    return (
      <form onSubmit={handleSubmit(onSubmit)} className="cro-form">
        <Field
          name="id"
          type="hidden"
          component="input"
          style={{ display: "none" }}
        />
        <CroField
          title={title}
          name={name}
          component={Input}
          fullWidth
          multiLine={multiLine}
          labelStyle={{ marginTop: 12 }}
          disabled={disabled}
          validate={[V.required]}
          maxlen={3000}
        />

        <CroLabeledCmp title="" rowStyles={{ display: "block" }}>
          {error && (
            <div className="error" style={{ flexBasis: "100%" }}>
              {error}
            </div>
          )}
          <div className="error">Povinná pole jsou označena hvězdičkou.</div>
          <div style={{ display: "flex", gap: 8 }}>
            <Button
              type="button"
              style={styles.buttons}
              label={submitLabel}
              disabled={submitting || disabled}
              onClick={handleSubmit(onSubmit)}
            />
            <Button
              type="button"
              style={styles.buttons}
              label="Zpět"
              disabled={submitting || disabled}
              onClick={goBack}
            />
          </div>
        </CroLabeledCmp>
      </form>
    );
  }
}

export default reduxForm({
  form: "rejectForm",
})(OneFieldForm);
